import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import Button from '../../../components/button/button';
import { EventCard } from './cards';
import {
  BOOTSTRAP_COLUMN_WIDTH,
  ANIMATION_DURATION,
} from '../../../app-constants';

class RepeatableContent extends Component {
  constructor(props) {
    super(props);
    const {
      numberInitialRowsToShow = 1,
      RepeatableInjectedComponent,
      cardClass,
      cardsPerRow,
      contentToMap,
      collapseSpacingOnMobile,
      truncateSummary,
      buttonText,
      callbackRequest,
      doNotIncludeMarginBottom,
    } = this.props;

    const reducedContentToMap = [];
    for (let card = 0; card < contentToMap.length; card += cardsPerRow) {
      reducedContentToMap.push(contentToMap.slice(card, card + cardsPerRow));
    }

    const MappedContent = () => reducedContentToMap.map((contentRow, rowIndex) => (
      <AnimateHeight
        duration={this.state.duration}
        height={this.getHeight(rowIndex)}
        delay={this.getDelay(rowIndex)}
        key={rowIndex.toString()}
      >
        <div className="row grid-12px">
          {contentRow.map((mapGroupItem, itemIndex) => (
            <div
              className={`col-12 col-sm-${BOOTSTRAP_COLUMN_WIDTH / cardsPerRow} ${collapseSpacingOnMobile ? 'collapse-mobile-spacing' : ''} ${doNotIncludeMarginBottom ? '' : 'mb-4'}`} // eslint-disable-line max-len
              key={itemIndex.toString()}
            >
              <EventCard cardClass={cardClass}>
                <RepeatableInjectedComponent
                  {...mapGroupItem}
                  truncateSummary={truncateSummary}
                  buttonText={buttonText || mapGroupItem.buttonText}
                  callbackRequest={callbackRequest}
                />
              </EventCard>
            </div>
          ))}
        </div>
      </AnimateHeight>
    ));

    this.state = {
      duration: ANIMATION_DURATION,
      rowsToShow: numberInitialRowsToShow,
      totalRows: reducedContentToMap.length,
      MappedContent,
    };
  }

  getDelay = (rowIndex) => {
    const { numberRowsToShowOnClick } = this.props;
    const { rowsToShow, duration } = this.state;
    return (rowIndex - (rowsToShow - numberRowsToShowOnClick)) * duration;
  };

  getHeight = (rowIndex) => {
    const { rowsToShow } = this.state;
    return rowIndex < rowsToShow ? 'auto' : '0';
  };

  showMoreRows = () => {
    const { rowsToShow } = this.state;
    const { numberRowsToShowOnClick } = this.props;
    this.setState({ rowsToShow: rowsToShow + numberRowsToShowOnClick });
  };

  render() {
    const {
      viewMoreText,
    } = this.props;
    const {
      rowsToShow,
      totalRows,
      MappedContent,
    } = this.state;
    return (
      <div>
        <MappedContent />
        {rowsToShow < totalRows &&
        <Button
          className="button clear mx-auto d-block vantage-view-more"
          onClick={this.showMoreRows}
          buttonText={viewMoreText}
        />
        }
      </div>
    );
  }
}

export default RepeatableContent;
